import React from 'react';
import { X, Check } from 'lucide-react';
import { motion } from 'framer-motion';
const comparisons = [{
  without: '3-5 horas semanales buscando info en YouTube sin llegar a nada',
  with: '10 minutos mirando la planilla y sabés exactamente qué hacer hoy'
}, {
  without: 'Siempre los mismos errores de precio y stock que no rota',
  with: '8 guías y estrategias listas para cada etapa del negocio'
}, {
  without: 'Publicás dos veces y abandonás porque "no funciona"',
  with: 'Instagram configurado como tienda que genera consultas sola'
}, {
  without: 'Sin sistema para que las clientas vuelvan solas',
  with: 'Cartera de clientas fiel que vuelve y te recomienda sola'
}, {
  without: 'No sabés cuánto ganás ni si el negocio vale la pena',
  with: 'Precio correcto y margen real en cada prenda que vendés'
}, {
  without: 'Sin hoja de ruta clara para el próximo nivel',
  with: 'Mapa claro hacia tu propia marca en 12 meses'
}, {
  without: 'Improvisás todo según la energía del día',
  with: 'Sistema de negocio que funciona aunque no estés presente'
}];
export function Comparison() {
  return <section className="w-full py-10 sm:py-20 bg-violet-rich/20" data-id="element-36">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8 sm:mb-12" data-id="element-38">
          <p className="text-gold text-xs sm:text-sm tracking-widest mb-3 sm:mb-4" data-id="element-39">
            LA REALIDAD
          </p>
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-white" data-id="element-40">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-41">
          <div data-id="element-42">
            <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 flex items-center gap-2" data-id="element-43">
              <X className="w-5 h-5 sm:w-6 sm:h-6 text-red-400" data-id="element-44" />
              SIN EL SISTEMA
            </h3>
            <div className="space-y-3 sm:space-y-4" data-id="element-45">
              {comparisons.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} whileHover={{
              x: 4,
              backgroundColor: 'rgba(248, 113, 113, 0.05)'
            }} className="bg-violet-deep/40 border border-red-400/20 rounded-lg p-3 sm:p-4 transition-colors" data-id="element-46">
                  <p className="text-violet-100/80 text-xs sm:text-sm" data-id="element-47">
                    {item.without}
                  </p>
                </motion.div>)}
            </div>
          </div>

          <div data-id="element-48">
            <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 flex items-center gap-2" data-id="element-49">
              <Check className="w-5 h-5 sm:w-6 sm:h-6 text-green" data-id="element-50" />
              CON EL SISTEMA
            </h3>
            <div className="space-y-3 sm:space-y-4" data-id="element-51">
              {comparisons.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} whileHover={{
              x: -4,
              backgroundColor: 'rgba(34, 197, 94, 0.05)'
            }} className="bg-violet-deep/40 border border-green/20 rounded-lg p-3 sm:p-4 transition-colors" data-id="element-52">
                  <p className="text-violet-100/80 text-xs sm:text-sm" data-id="element-53">
                    {item.with}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}